import React, { FunctionComponent } from 'react';

import SingleAddressStep from 'scenes/common/components/Steps/Addresses/SingleAddressStep';
import { LandlordFullPageProps } from 'scenes/landlord/types';
import { getMainAddress } from 'scenes/landlord/selectors';
import analytics from 'scenes/landlord/analytics';

export const QUESTION = 'What is the address of the property?';
export const HELP_TEXT =
  'Please begin typing your address then select it from the options in the dropdown menu.';
export const VALIDATION_ERROR_MESSAGE = 'Please select property address';
export const STATE_KEY = 'mainAddress';

const MainAddressStep: FunctionComponent<LandlordFullPageProps> = ({
  funnelState,
  onNext,
}) => (
  <SingleAddressStep
    onNext={onNext}
    question={QUESTION}
    helpText={HELP_TEXT}
    validationError={VALIDATION_ERROR_MESSAGE}
    stateKey={STATE_KEY}
    defaultStateValue={getMainAddress(funnelState)}
    onClickCallUs={() => analytics().callUs(funnelState)}
    onApiError={() => {}}
  />
);

export default MainAddressStep;
